var e={img:"index-module__img__w-Rc5"};export{e as default};
//# sourceMappingURL=index.module.scss.js.map
